<template>
    <div>
      <Header></Header>
      <div style="text-align: center;margin: 40px ;">
        <!-- <p style="color:red;font-size:32px; font-weight: 600;">一键复制AI对话生成内容公式工具ihelper.cc</p> -->
        <p style="color:red;font-size:32px;font-weight: 600;"><a style="color: red;" target="_blank" href="https://www.ihelper.cc">一键复制AI数学公式工具 https://www.ihelper.cc</a></p>
        <p style="color:blue;font-size:22px;">专业的事情专业的人做，花点钱给自己节省几天的时间很划算</p>
        <!-- <p style="color:red;font-size:22px;font-weight: 600;">客服每天7:00-24:00在线，有需要充值的同学请联系客服</p> -->
        <p style="color:black;font-size:22px;"><a style="color:red" target="_blank" href="https://www.bilibili.com/video/BV1Gu411m7xH/?vd_source=f92cf374028190e1d5f205be67ee3d2c">点击这里查看扩展插件安装视频</a></p>
      </div>
      <div class="row">
        <div class="item">
          <p class="title">百度搜索指数导出</p>
          <Button @click="go_to('/homeedit')" class="btn">开始使用</Button>
          <a class="sec" href="/introne">使用说明</a>
          <a class="sec" href="https://cmshj.oss-cn-beijing.aliyuncs.com/data/dtool.zip?v=2">Chrome扩展下载</a>
        </div>
        <div class="item">
          <p class="title">抖音指数导出</p>
          <Button @click="go_to('/juliang')" class="btn">开始使用</Button>
          <a class="sec" href="/introne">使用说明</a>
          <a class="sec" href="https://cmshj.oss-cn-beijing.aliyuncs.com/data/dtool.zip?v=2">Chrome扩展下载</a>
        </div>
        <div class="item">
          <p class="title" style="color:#ff8600;">一键复制AI数学公式工具</p>
          <Button @click="go_newpage('https://www.ihelper.cc')" class="btn">点击查看</Button>
          <p class="sec">Deepseek、豆包生成的数学公式、化学公式复制到word功能，对话提问列表功能</p>
        </div>
        <div class="item">
          <p class="title" style="color:#ff8600;">股票日K线数据下载工具</p>
          <Button @click="go_newpage('https://pan.baidu.com/s/1NmQ334SZbFo4xMfN5t4fMA?pwd=5xmr')" class="btn">点击下载</Button>
          <p class="sec">Windows平台软件，支持批量下载</p>
          <a class="sec" target="_blank" href="https://pan.baidu.com/s/1NmQ334SZbFo4xMfN5t4fMA?pwd=5xmr">百度网盘提取</a>
        </div>
        <div class="item">
          <p class="title">百度品牌指数工具</p>
          <Button @click="go_to('/brand')" class="btn">开始使用</Button>
          <a class="sec" href="/introne">使用说明</a>
          <a class="sec" href="https://cmshj.oss-cn-beijing.aliyuncs.com/data/dtool.zip?v=2">Chrome扩展下载</a>
        </div>
        <div class="item">
          <p class="title">百度资讯指数导出</p>
          <Button @click="go_to('/feed')" class="btn">开始使用</Button>
          <a class="sec" href="/introne">使用说明</a>
          <a class="sec" href="https://cmshj.oss-cn-beijing.aliyuncs.com/data/dtool.zip?v=2">Chrome扩展下载</a>
        </div>
        <div class="item" style="justify-content: left;">
          <p class="title" >下载百度指数Python源代码</p>
          <Button @click="go_to('/intrcode')" class="btn">详情介绍</Button>
          <p class="sec">下载搜索/资讯指数的Python源代码</p>
          <p class="sec">需要有一定的Python代码能力</p>
        </div>
        <div class="item" style="justify-content: left;">
          <p class="title">结果处理Python源代码</p>
          <Button @click="go_to('/intrcalc')" class="btn">详情介绍</Button>
          <p class="sec">年月汇总、均值、合并Python源代码</p>
          <p class="sec">需要Python环境和pandas模块</p>
        </div>
      </div>

      <p class="xc-p"><router-link style="color: red;text-decoration:underline;" to="/login">新注册用户</router-link>送10个采集请求次数,可立即体验</p>
      <div class="row" style="text_align: left;">
        <div style="margin: 40px 0;">
          <p class="sp-p">采集结果都是<span style="color:blue;">日度数据</span>，如下图样例所示的Excel表格</p>
          <img class="sp-img" src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/jieguo.png" alt="">
        </div>
        <!-- <div style="width:20px;"></div>
        <div style="margin: 40px 0;">
          <p style="font-size:18px; margin: 10px 0;">微信扫描联系客服</p>
          <img style="width: 200px;" src="https://cmshj.oss-cn-beijing.aliyuncs.com/data/qrcode.png" alt="">
        </div> -->
      </div>

    </div>
</template>
<script>
// import helper from '../lib/helper'
import Header from './header'
export default {
  components: {
    Header
  },
  data () {
    return {
      page: 1,
      limit: 2,
      totalcount: 0,
      data1: []
    }
  },
  computed: {
    menuitemClasses: function () {
      return {
      }
    }
  },
  mounted () {
  },
  methods: {
    go_to (uri) {
      console.log(' goto : ', uri)
      this.$router.push(uri)
    },
    go_newpage (url) {
      window.open(url, '_blank')
    },
    onchange (e) {
      // console.log(e)
      // this.page = e
      // this.getList()
    }
  }
}
</script>
<style lang="less" scoped>
.ab {
  margin: 6px;
  background: blue;
  color: white;
  font-weight: 600;
  padding: 3px 15px;
  border-radius: 4px;
  border-color: #dcdee2;
  border: 1px solid transparent;
  // transition: color .2s linear,background-color .2s linear,border .2s linear,box-shadow .2s linear;
  font-size: 14px;
  // height: 32px;
  vertical-align: middle;
  line-height: 1.5;
}
.row {
  width: 100%;
    display: flex;
    justify-content: center;
    flex-direction: row;
    flex-wrap: wrap;
}
.item {
  border: 2px solid #4e6ef2;
  width: 22vw;
  margin: 30px;
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  padding: 30px;
  border-radius: 6px;
  text-align: center;
  .title {
    font-size: 20px;
    font-weight: 600;
  }
  .btn  {
    margin: 6px;
    background: blue;
    color: white;
    font-weight: 600;
  }
  .sec {
    font-size: 16px;
    font-weight: 400;
    color: #797EF6;
    // color: #1e2f97
  }
}
.sp-img {
    width: 60vw;
  }
.sp-p {
  font-size:18px;
  margin: 10px 0;
}
.xc-p {
  color:red;
  font-size:28px;
}

@media (max-width: 768px){
  .item{
    width: 100vw;
  }
  .sp-img {
    width: 80vw;
  }
  .sp-p {
    font-size:12px;
    margin: 10px 0;
  }
  .xc-p {
    font-size:14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue